<template>
  <div>
    <nav class="sidebar-nav">
      <h2 class="sidebar-nav-h2" @click="menuVisible = !menuVisible">
        <a class="sidebar-nav-a">{{ appName }} MENU</a>
      </h2>
      <ul class="sidebar-nav-list" :class="[menuVisible ? 'show' : 'hide']">
        <template v-for="(link, index) in links">
          <template v-if="link.icon">
            <template v-if="link.premium ? isAmpress: true">
              <li class="sidebar-nav-item" :key="index" @click="sidebarOpen = false">
                <router-link :to="link.path" class="sidebar-nav-item-a">{{ link.ja }}<i class="fa fa-angle-right" aria-hidden="true"></i></router-link>
              </li>
            </template>
          </template>
        </template>
        <li class="sidebar-nav-item">
          <a class="sidebar-nav-item-a" @click="dialogVisible = true">Logout</a>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
import router from '@/router'
import MimicAmpSidebar from '@/components/mimic-amp/MimicAmpSidebar'

export default {
  name: 'app-sidebar',
  components: {
    'mimic-amp-sidebar': MimicAmpSidebar
  },
  data: function () {
    return {
      links: router.options.routes,
      menuVisible: false
    }
  },
  computed: {
    appName: {
      get () { return this.$store.getters['app/name'] }
    }
  },
  methods: {
    logout: function () {
      this.$emit('logout')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~scss/variables';
@import '~scss/theme';

.sidebar {
  &-nav {
    &-h2 {
      margin-bottom: 0;
      padding: .75em;
      font-size: 1.2em;
      color: #fff;
      background-color: $--color-primary;
    }
    &-list {
      padding: 0 1em;
      &.show {
        display: block;
      }
      &.hide {
        display: none;
      }
    }
    &-item {
      border-bottom: 1px solid #fafafa;
      &-a {
        display: block;
        padding: .75em 0;
        position: relative;
        & .fa {
          margin: auto;
          width: 1em;
          height: 1em;
          position: absolute;
          top: 0;
          right: 1em;
          bottom: 0;
        }
      }
    }
  }
}

.ampress {
}

.evsmacloud {
}

</style>



// WEBPACK FOOTER //
// src/components/app/AppSidebar.vue